export default {
  // replace {mode} as config name ex. yarn serve --mode commu
  // yarn serve --mode {mode}
  // yarn build --mode {mode}
  env: process.env.VUE_APP_TYPE,
  configs: {
    serverUrl: process.env.VUE_APP_SERVER_URL,
    liffId: process.env.VUE_APP_LIFF_ID
  },
  thaiairways: {
    serverUrl: 'https://thaiairways.herokuapp.com/',
    pageid: ['103615798930866', '304177952292']
  },
  thailandpostmart: {
    // pageid: "396306053873110", pageid_test: '115414076948160'
    pageid: { pagename: '396306053873110', with_shipping_list: false },
    serverUrl: 'https://api-enterprise.zwiz.app/tero/shop/',
    auth: {
      'x-api-key': '7@cuTnLXX1TK78mHOJF#wI$NkkyG8A'
    }
  },
  color: {
    primary: process.env.VUE_APP_DEFAULT_THEME_COLOR
  },
  getConfig: function (type) {
    if (this.configs.hasOwnProperty(type)) {
      return this.configs[type]
    } else {
      throw 'Not found this variable'
    }
  }
}
